import React from 'react'
import Button from '../button/Button'
import styles from './delete-confirmation.module.scss'

interface IProps {
  handleDelete?: () => void
  close?: () => void
  title: string
  loading?: boolean
  text: string
  buttonText: string
}

const DeleteConfirmation = React.memo(function DeleteConfirmation({ handleDelete, close, title, text, buttonText, loading }: IProps) {
  return (
    <div className={styles.deleteConfirmation}>
      <div className={styles.content}>
        <svg xmlns="http://www.w3.org/2000/svg" className={styles.icon} viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
        </svg>
        <h6 className={styles.title}>{title}</h6>
        <div className={styles.bodyText} dangerouslySetInnerHTML={{ __html: text }} />
      </div>
      <footer className={styles.footer}>
        <Button type='secondary' label='Annuller' handleClick={close} />
        <Button type='destructive' label={buttonText} modifiers='tw-ml-auto' loading={loading} handleClick={handleDelete} />
      </footer>
    </div>
  )
})


export default DeleteConfirmation